import { Activity, TextLine, Wrapper } from "./styles";
import TooltipButton from "components/TooltipButton/TooltipButton";

const ScheduleActivityCard = ({
    className,
    classList, header,
    quantityCells,
    visualQuantityCells = quantityCells,
    icon,
    dialogUpdate,
    superheader = null, activity, isBoss = false
}) => {
    const { title, subtitle } = header;
    const isActivityOfLessThanOneHour = (!visualQuantityCells || visualQuantityCells >= 4);
    const getWrapperClassName = () => {
        const wrapperClassList = [];
        className && wrapperClassList.push(className);
        classList && wrapperClassList.push(...classList);
        return wrapperClassList.join(" ");
    }
    return (
        <Activity
            ref={activity}
            zIndex={dialogUpdate.value && 901}>
            {superheader}
            <Wrapper
                className={getWrapperClassName()}
                onClick={isBoss ? undefined : () => dialogUpdate.toggle()}
                heightRatio={visualQuantityCells}>
                <header>
                    <h5 title={title}>{title}</h5>
                    {(subtitle && isActivityOfLessThanOneHour) && <span title={subtitle}>{subtitle}</span>}
                </header>
                {visualQuantityCells < 4 && <Information {...header} />}
                {icon}
            </Wrapper>
        </Activity>
    );
}
const Information = ({
    title, subtitle
}) => {
    return (
        <TooltipButton
            className="info-btn"
            content={
                <>
                    <TextLine title={title}>{title}</TextLine>
                    <br />
                    <TextLine title={subtitle}>{subtitle}</TextLine>
                </>}
            tooltipProps={{
                x: "-90%", y: "-175%",
                width: "200px",
                height: "60px",
                after: {
                    x: "375%", y: "0",
                    angle: "38deg"
                }
            }}
            size={18} />
    );
}

export default ScheduleActivityCard;
